import { render, staticRenderFns } from "./MenuPortineria.vue?vue&type=template&id=2a3eded7&"
import script from "./MenuPortineria.vue?vue&type=script&lang=ts&"
export * from "./MenuPortineria.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports